(() => {
  if (window.animavaScrollTimelines) return;
  window.animavaScrollTimelines = true;
  let frame = 0;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function update() {
    frame = 0;
    const anchor = window.innerHeight * 0.55;
    document.querySelectorAll('.pctl, .pctl-timeline .tl-steps').forEach(track => {
      const details = track.closest('details');
      if (details && !details.open) return;
      const compact = track.classList.contains('pctl');
      const rail = track.querySelector(compact ? '.pctl-rail' : '.tl-rail');
      const snack = track.querySelector(compact ? '.pctl-snack' : '.tl-snack');
      const fill = track.querySelector(compact ? '.pctl-fill' : '.tl-fill');
      if (!rail || rail.offsetHeight === 0) return;
      const rect = rail.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (anchor - rect.top) / rect.height));
      if (snack) {
        snack.style.top = (rail.offsetTop + (reducedMotion.matches ? 0 : progress * rail.offsetHeight)) + 'px';
        snack.style.transform = 'translate(-50%, -50%)';
      }
      if (fill) fill.style.height = (progress * 100) + '%';
      track.querySelectorAll('.tl-step').forEach(step => step.classList.remove('is-dim'));
    });
  }
  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('load', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);
  reducedMotion.addEventListener('change', schedule);
  const observer = new MutationObserver(records => {
    if (records.some(record => record.type === 'childList')) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();